import { cn } from "@/modules/lib/utils"
import { ProgramHeaderCenterView } from "@modules/programs/components/programHeader/programHeaderCenterView"
import { ProgramHeaderLeftView } from "@/modules/programs/components/programHeader/programHeaderLeftView"
import { ProgramHeaderRightView } from "@modules/programs/components/programHeader/programHeaderRightView"
import { useProgramRights } from "@/modules/programs/hooks/useProgramRights"
import { TrainingAdsSection } from "@/modules/training/components/trainingAdsSection"

type ProgramHeaderProps = {
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramHeader({ programId, className, ...props }: ProgramHeaderProps) {
  const { isAuthor, isAcceptedSharedCoach } = useProgramRights(programId)
  const canSeeActions = (isAuthor || isAcceptedSharedCoach) && programId

  return (
    <div className={cn("flex max-h-52 min-h-52 w-full justify-between gap-1 lg:gap-2 xl:gap-3", className)} {...props}>
      <ProgramHeaderLeftView className="w-1/5" programId={programId} />
      <ProgramHeaderCenterView className="grow" programId={programId} />
      {canSeeActions ? (
        <ProgramHeaderRightView programId={programId} className="w-1/4" />
      ) : (
        <TrainingAdsSection className="h-52 min-w-100 rounded-3xl bg-surface-background-secondary" />
      )}
    </div>
  )
}
